import { Component, Vue } from 'vue-property-decorator';
import sectorModule from '@/store/modules/sector.module'
import { Sector } from '@/shared/dtos/sector';
import DxDataGrid, { DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';



@Component({
    components: {
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxFilterRow,
        DxFilterPanel,
        DxExport,
        DxColumnChooser
    },
})

export default class SectorLista extends Vue {

    public pageSize: number = 15;
    public maxWidth: number = 500;
    public addHidden = true;
    public loading = false;
    public search = '';
    public sector: Sector = new Sector();

    public get sectorList() {
        return sectorModule.sectors;
    }

    public get columns() {
        return [
            { dataField: 'id', allowEditing: false },
            { dataField: 'code', caption: this.$tc('maestro-configuracion.codigo'), allowEditing: true },
            { dataField: 'description', caption: this.$tc('maestro-configuracion.descripcion'), allowEditing: true},
        ]
    }

    public mounted() {
        sectorModule.getSectors();
    }

    public rowInserted(e: any){
        sectorModule.insertarSector(e.data);
    }

    public rowUpdated(e: any){
        sectorModule.modificarSector(e.data);
    }
    
    public rowRemoved(e: any){
        sectorModule.eliminarSector(e.key);
    }

    public initNewRow(e: any){
        e.data.id = 0;
    }
}